var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGptbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463340",
    x: 5.61719,
    y: 5.61523,
    width: 8.76871,
    height: 8.76871,
    rx: 1,
    fill: "white",
    stroke: "#2E3438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "AI"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 37260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5078 7.93457H12.3109V12.0644H11.5078V7.93457Z",
    fill: "#2E3438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.77225 11.2155H8.34715L8.07946 12.0644H7.23438L8.61485 7.93457H9.52817L10.8982 12.0644H10.0216L9.77225 11.2155ZM9.54654 10.5038L9.06364 8.87877L8.56499 10.5038H9.54654Z",
    fill: "#2E3438"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463465",
    x: 8.15625,
    y: 4,
    width: 0.923022,
    height: 1.61529,
    rx: 0.2,
    fill: "#2E3438"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463479",
    x: 8.15625,
    y: 14.3838,
    width: 0.923022,
    height: 1.61529,
    rx: 0.2,
    fill: "#2E3438"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463466",
    x: 10.9219,
    y: 4,
    width: 0.923022,
    height: 1.61529,
    rx: 0.2,
    fill: "#2E3438"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463480",
    x: 10.9219,
    y: 14.3838,
    width: 0.923022,
    height: 1.61529,
    rx: 0.2,
    fill: "#2E3438"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463481",
    x: 16,
    y: 8.1543,
    width: 0.923022,
    height: 1.61529,
    rx: 0.2,
    transform: "rotate(90 16 8.1543)",
    fill: "#2E3438"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463482",
    x: 5.61719,
    y: 8.1543,
    width: 0.923022,
    height: 1.61529,
    rx: 0.2,
    transform: "rotate(90 5.61719 8.1543)",
    fill: "#2E3438"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463483",
    x: 16,
    y: 10.9229,
    width: 0.923022,
    height: 1.61529,
    rx: 0.2,
    transform: "rotate(90 16 10.9229)",
    fill: "#2E3438"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463484",
    x: 5.61719,
    y: 10.9229,
    width: 0.923022,
    height: 1.61529,
    rx: 0.2,
    transform: "rotate(90 5.61719 10.9229)",
    fill: "#2E3438"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGptbox);
export default __webpack_public_path__ + "static/media/gptbox.be02e167560e73226d89ca4681188f1e.svg";
export { ForwardRef as ReactComponent };